import { CEAlertSubscriptionBase } from './ce-alert-subscription-base'


export class CEAlertSubscription extends CEAlertSubscriptionBase {

}